module.exports = __webpack_public_path__ + "img/special_dark.b4150ec4.png";